import { motion } from "framer-motion";

const CrescentSpinner = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className="animate-spin"
  >
    <path
      d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22"
      stroke="#F59E0B"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);

const DisconnectedOverlay = () => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    className="fixed inset-0 z-[500] flex items-center justify-center bg-[#1A1A1A]/90 backdrop-blur-sm"
  >
    <div className="flex flex-col items-center gap-3 text-center">
      <h2 className="text-xl font-semibold text-white">
        EverTutor Disconnected
      </h2>
      <div className="flex items-center gap-2 text-[#A1A1AA]">
        <CrescentSpinner size={16} />
        <span className="text-sm">Trying to reconnect...</span>
      </div>
    </div>
  </motion.div>
);

export default DisconnectedOverlay;
